import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { map, is, identity, take, takeLast } from 'ramda';
import { injectIntl, intlShape } from 'react-intl';
import { Row, Col } from 'react-flexbox-grid';
import { Collapse } from 'react-collapse';
import { buttonArea } from './HistoryCollapseContainer.less';

import normalize from 'lib/normalize';
import NoEntriesText from 'routes/Documents/components/NoEntriesText';
import ActionButton from 'components/ActionButton';

class HistoryCollapseContainer extends Component {
  state = { collapse: true };

  showAll = () => this.setState({ collapse: false });
  showLimit = () => this.setState({ collapse: true });

  render() {
    const { mapper, limit, noNormalize, documents, emptyText, intl, sorter = identity } = this.props;
    const {
      intl: { formatMessage },
    } = this.props;

    if (is(Array, documents) && documents.length > 0) {
      return (
        <div>
          <Row>
            <Col xs>
              {map(d => mapper(d, intl), take(limit, sorter(!noNormalize ? normalize(documents) : documents)))}
              <Collapse isOpened={!this.state.collapse}>
                {!this.state.collapse &&
                  map(
                    d => mapper(d, intl),
                    takeLast(documents.length - limit, sorter(!noNormalize ? normalize(documents) : documents)),
                  )}
              </Collapse>
            </Col>
          </Row>
          {documents.length > limit && (
            <Row center="xs" end="sm" middle="xs" className={buttonArea}>
              <Col smOffset={6} mdOffset={7} lgOffset={8} xs={6} sm={3} md={2}>
                {this.state.collapse && <div>{formatMessage({ id: 'dictionary.showingOnly' }, { limit: limit })}</div>}
              </Col>
              <Col xs={6} sm={3} md={3} lg={2}>
                {this.state.collapse && (
                  <ActionButton
                    localeId="dictionary.showAll"
                    localeValues={{ hidden: documents.length - limit }}
                    border
                    secondary
                    onClick={this.showAll}
                  />
                )}
                {!this.state.collapse && (
                  <ActionButton localeId="dictionary.hide" align="right" border secondary onClick={this.showLimit} />
                )}
              </Col>
            </Row>
          )}
        </div>
      );
    } else if (is(Array, documents) && documents.length === 0 && emptyText)
      return (
        <div>
          <NoEntriesText emptyText={emptyText} />
        </div>
      );
    else return null;
  }
}

HistoryCollapseContainer.propTypes = {
  mapper: PropTypes.func.isRequired,
  limit: PropTypes.number.isRequired,
  noNormalize: PropTypes.bool,
  documents: PropTypes.array,
  emptyText: PropTypes.string,
  sorter: PropTypes.func,
  intl: intlShape,
};

export default injectIntl(HistoryCollapseContainer);
